export default __webpack_public_path__ + "static/media/DownloadIcon2.897cacb6.svg";